<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" data-testid="menu-user-profile">
  <span class="relative">
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'">
    </mat-icon>
  </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>Signed in as</span>
      <span class="mt-1.5 text-md font-medium" data-testid="label-user-email">{{user?.email}}</span>
    </span>
  </button>
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item (click)="profile()" data-testid="menu-user-profile-link">
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span>Profile</span>
  </button>
  <button mat-menu-item (click)="changePassword()" data-testid="menu-user-change-password">
    <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon>
    <span>Change Password</span>
  </button>
  @if (roles?.length == 1) {
    <button mat-menu-item data-testid="menu-user-admin">
      <mat-icon [svgIcon]="'heroicons_solid:shield-check'"></mat-icon>
      <span class="break-words">{{roleString}}</span>
    </button>
  }
  @if (roles?.length > 1) {
    <button matRipple [matMenuTriggerFor]="projectsMenu" mat-menu-item
      (click)="$event.stopPropagation();" data-testid="menu-user-admin">
      <mat-icon [svgIcon]="'heroicons_solid:shield-check'"></mat-icon>
      Change Role ({{selectedTab}})
    </button>
  }

  <mat-menu #projectsMenu="matMenu" [xPosition]="'before'">
    @for (tab of tabs; track tab; let idx = $index) {
      <button mat-menu-item
        (click)="onChangeRole(idx, true)">{{tab}}
      </button>
    }
  </mat-menu>
  <button mat-menu-item (click)="goToBuild()" data-testid="menu-user-build">
    <mat-icon [svgIcon]="'heroicons_outline:office-building'"></mat-icon>
    <span>Build</span>
  </button>
  <button mat-menu-item (click)="clearCache()" data-testid="menu-user-clear-cache">
    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
    <span>Clear Cache</span>
  </button>
  <!-- <button mat-menu-item>
  <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
  <span>Settings</span>
</button>
<button mat-menu-item [matMenuTriggerFor]="adminMenu">
  <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
  <span>Admin</span>
</button> -->
<mat-divider class="my-2"></mat-divider>
<button mat-menu-item (click)="signOut()" data-testid="menu-user-logout">
  <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
  <span>Sign out</span>
</button>
</mat-menu>

<mat-menu class="user-status-menu" #adminMenu="matMenu">
  <a mat-menu-item [routerLink]="['/admin/personnel/users']">
    <span>Users</span>
  </a>
  <a mat-menu-item [routerLink]="['/admin/settings']">
    <span>Settings</span>
  </a>
</mat-menu>
